<p-sidebar [(visible)]="show" styleClass="sidebar_dtic" position="right">
  {{ "mods_apps.titulo" | translate }}
  <div class="row">
    <div
      class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top margin-bottom"
    >
      <p-tabMenu [model]="tabs" [activeItem]="tabs[index]">
        <ng-template pTemplate="item" let-item>
          {{ item.label | translate }}
        </ng-template>
      </p-tabMenu>
      <ng-container [ngSwitch]="index">
        <ng-container *ngSwitchCase="0">
          <div class="row" *ngIf="config.SISTEMA.LOADS.MODULOS.BUTTON">
            <div
              class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top small text-center"
            >
              {{ "mods_apps.modulos.subtitulo" | translate }}<br />
              <span class="text-primary strong">{{
                app_selected?.nombre
              }}</span>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top">
              <ng-container *ngFor="let mod_group of modulos">
                {{ mod_group.grupo }}
                <div class="row box_modulos">
                  <ng-container
                    *ngFor="let modulo of mod_group.modulos; let ult = last"
                  >
                    <div
                      class="col-lg-12 col-md-12 col-sm-12 col-xs-12 container_modulo {{
                        modulo.cod_modulo == modulo_selected.cod_modulo
                          ? 'modulo_activo'
                          : ''
                      }} {{ !ult ? 'margin-bottom' : '' }}"
                      title="{{ modulo.descripcion }}"
                      (click)="go_modulo_app(modulo, 'modulo')"
                    >
                      <table>
                        <tr>
                          <td style="width: 32px">
                            <img
                              class="img-profile rounded-circle img-modulo-aplicacion"
                              [src]="modulo.icono"
                              (error)="
                                $event.target.src =
                                  config.SISTEMA.URL.PATH404IMG
                              "
                            />
                          </td>
                          <td>
                            {{ modulo.nombre }}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="1">
          <div class="row" *ngIf="config.SISTEMA.LOADS.APPS.BUTTON">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top">
              <ng-container *ngFor="let app_group of aplicaciones">
                <ng-container *ngIf="app_group.apps.length > 0">
                  {{ app_group.grupo }}
                  <div class="row box_apps">
                    <ng-container
                      *ngFor="let app of app_group.apps; let ult = last"
                    >
                      <div
                        class="col-lg-12 col-md-12 col-sm-12 col-xs-12 container_app {{
                          app.id == app_selected.id ? 'app_activa' : ''
                        }} {{ !ult ? 'margin-bottom' : '' }}"
                        (click)="go_modulo_app(app, 'aplicacion')"
                      >
                        <table>
                          <tr>
                            <td style="width: 32px">
                              <img
                                class="img-profile rounded-circle img-modulo-aplicacion"
                                [src]="app.icono"
                                (error)="
                                  $event.target.src =
                                    config.SISTEMA.URL.PATH404IMG
                                "
                              />
                            </td>
                            <td>
                              {{ app.nombre }}
                            </td>
                          </tr>
                        </table>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</p-sidebar>
